import { Component, Input, OnDestroy, type OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ReelsService } from '../../../../../services/reels.service';
import { UnitssService } from '../../../../../services/unitss.service';

@Component({
	selector: 'app-unit-evidences',
	templateUrl: './unit-evidences.component.html',
	styleUrls: ['./unit-evidences.component.scss'],
})
export class UnitEvidencesComponent implements OnInit, OnDestroy {
	@Input() data: any = {};

	public evidences = [];
	public sortOrder: number;
	public sortField: string;
	public maxDate: Date;
	public filterDate: Date = new Date();
	paginationData: any = {
		current_page: 1,
		from: 1,
		last_page: 0,
		per_page: 0,
		to: 0,
		total: 0
	};

	private atComponentDestroy = new Subject();

	constructor(
		private reelService: ReelsService,
		private unitsService: UnitssService
	) {

	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	ngOnInit(): void {
		this.maxDate = new Date();
		this.getEvidences(this.filterDate.toLocaleDateString());
	}

	/**
	 * Alias function for getEvidences
	 * @param event
	 */
	changeEvidences(event): void {
		this.getEvidences(event.toLocaleDateString());
	}

	/**
	 * Get Evidences for certain media by date
	 * @param date
	 */
	getEvidences(date): void {
		this.evidences = [];
		const parseDate = date.split('/');

		this.reelService.getEvidences(`${parseDate[2]}-${parseDate[1] < 10 ? '0' + parseDate[1] : parseDate[1]}-
		${parseDate[0] < 10 ? '0' + parseDate[0] : parseDate[0]}`,
			this.data?.raspberry_number).subscribe((data: any) => {
				this.evidences = data.response;
			});
	}

	/**
	 * Transform the date into human readable
	 * @param evidence
	 * @returns
	 */
	public getDataByUrl(evidence: string) {
		return this.unitsService.getDataByUrl(evidence);
	}
}
